import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import { storeTokens } from "../Home/auth";
import "./UserSignIn.css";
import bgimage from "../Home/bg-image.webp";

const BASE_PATH = process.env.REACT_APP_BASE_PATH || "/als";

export default function UserSignIn() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    role: "",
  });

  const [error, setError] = useState(""); // New error state

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(""); // Clear error on input change
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password, role } = formData;

    if (!email || !password || !role) {
      setError("Please enter email, password, and select a role!");
      return;
    }

    try {
      const response = await AxiosInstance.post(
        `companies/user/signin/${email}/`,
        { password, role }
      );

      const data = response.data;
      console.log("Login response:", data);

      // Handle roles array - backend returns roles as an array
      const userRole = Array.isArray(data.roles) ? data.roles[0] : data.role;
      
      if (!userRole) {
        setError("Role information not found in response.");
        return;
      }

      // Block sign-in if role is Trainer
      if (userRole === "Trainer") {
        setError("Role not matched.");
        return;
      }

      storeTokens(data);
      localStorage.setItem("userId", data.user_id);
      localStorage.setItem("role", userRole);
      localStorage.setItem("email", email);
      if (data.status) {
        localStorage.setItem("status", data.status);
      }

      if (userRole === "Company_Admin") {
        navigate("/company-details");
      } else {
        navigate("/user-profile");
      }
    } catch (error) {
      console.error("Sign-in error:", error);
      if (error.response) {
        setError(error.response.data?.error || "Invalid credentials.");
      } else {
        setError("An error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="user-signin-container position-relative">
      <img src={bgimage} alt="Background" className="user-bg-img" />

      <div className="signin-box position-absolute top-50 end-0 translate-middle-y bg-white shadow p-4 rounded">
        <div className="acharya-logo-container">
          <img
            width="100"
            height="80"
            src="https://acharyasol.com/images/logo.png"
            className="als-logo"
            alt="Open Learnings"
          />
          <div className="acharya-headlines">
            <h3>Open Learnings</h3>
          </div>
        </div>

        <h3 className="mb-4">User Sign In</h3>
        <form onSubmit={handleSubmit}>
          {/* Role Selection */}
          <div className="mb-3">
            <div className="d-flex justify-content-center gap-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  id="admin"
                  name="role"
                  value="Company_Admin"
                  checked={formData.role === "Company_Admin"}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="admin">Admin</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  id="user"
                  name="role"
                  value="user"
                  checked={formData.role === "user"}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="user">Employee</label>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Password */}
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          {/* Error Message */}
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {/* Forgot Password */}
          <div className="d-flex justify-content-end mb-3">
            <span
              className="green-hover-link"
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate("/forgot-password", { state: { userType: "user" } })
              }
            >
              Forgot Password?
            </span>
          </div>

          {/* Submit Button */}
          <div className="d-grid mt-3">
            <button type="submit" className="btn btn-success">Sign In</button>
          </div>
        </form>
        <div className="mt-3 d-flex justify-content-between">
          <small className="signin-text">
            Don’t have an account?{" "}
            <span
              className="green-hover-link"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/UserSignup")}
            >
              Sign Up
            </span>
          </small>
          <small className="signin-text">
            <a href={BASE_PATH} className="green-hover-link">
              Home
            </a>
          </small>
        </div>
      </div>
    </div>
  );
}
